import { endOfDay, isBefore, startOfToday } from 'date-fns';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

export function isTaskOverdue({ isComplete, endDate }: { isComplete: boolean; endDate: Date }) {
    if (isComplete) {
        return false;
    }

    return isDateOverdue(endDate);
}

export function isDateOverdue(date: Date): boolean {
    return isBefore(endOfDay(date), startOfToday());
}

export function isTaskAssignedToYou({ assignees }: Task, loggedInUserId: number) {
    return assignees.some((assigneeId) => assigneeId === loggedInUserId);
}
